import { AbstractControl, ValidationErrors } from '@angular/forms';
import { militaryTimeToMinutes } from 'server/shared/helpers/time';

type TimeTrackingFormValue = {
  from: string;
  to: string;
  pause: string;
  correctionReason?: string;
  dispoCorrectionReason?: string;
};

export function customValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const values: TimeTrackingFormValue[] = control.value;
  if (!values || !values.length) {
    return null;
  }
  for (let i in values) {
    const error = validateTimeTracking(values[i]);
    if (error) {
      return error;
    }
  }
  let sortedTimeTrackings = values.sort(
    (a, b) => militaryTimeToMinutes(a.from) - militaryTimeToMinutes(b.from),
  );
  for (let i = 0; i < sortedTimeTrackings.length; i++) {
    const currentTimeTracking = sortedTimeTrackings[i];
    const nextTimeTracking = sortedTimeTrackings[i + 1];
    if (
      nextTimeTracking &&
      militaryTimeToMinutes(currentTimeTracking.to) >
        militaryTimeToMinutes(nextTimeTracking.from)
    ) {
      return {
        message: 'overlappingTrackings',
      };
    }
  }
  if (control.value?.to) return null;
  return null;
}

function validateTimeTracking(
  value: TimeTrackingFormValue,
): ValidationErrors | null {
  if (value.from === value.to) {
    return {
      message: 'badTimeSpan',
    };
  }
  const fromMinutes = militaryTimeToMinutes(value.from);
  let toMinutes = militaryTimeToMinutes(value.to);
  const pauseMinutes = militaryTimeToMinutes(value.pause);
  if (fromMinutes > toMinutes) {
    toMinutes = toMinutes + 1440;
    if (toMinutes - fromMinutes < pauseMinutes) {
      return {
        message: 'pauseTooBig',
      };
    }
  } else {
    if (toMinutes - fromMinutes < pauseMinutes) {
      return {
        message: 'pauseTooBig',
      };
    }
  }
  return null;
}
